function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#BFB7B6",
  d: "M20.578 8.906H18.65l-.276-.736a4.48 4.48 0 00-1.65-2.119 4.48 4.48 0 00-2.564-.801H9.84a4.48 4.48 0 00-2.563.801 4.48 4.48 0 00-1.65 2.119l-.277.736H3.422a.422.422 0 00-.4.556l.281.843a.422.422 0 00.4.289h1.013l-.001.005a2.249 2.249 0 00-1.153 1.964v1.687c0 .57.213 1.09.563 1.487v2.17c0 .465.378.843.844.843h1.687a.844.844 0 00.844-.844V16.5h9v1.406c0 .466.378.844.844.844h1.687a.844.844 0 00.844-.844v-2.169a2.24 2.24 0 00.563-1.487v-1.687c0-.844-.465-1.58-1.153-1.964l-.001-.005h1.013a.422.422 0 00.4-.289l.281-.843a.422.422 0 00-.4-.556zM7.732 8.96A2.26 2.26 0 019.84 7.5h4.322c.933 0 1.78.587 2.107 1.46l.507 1.353h-9.55l.507-1.353zm-1.638 5.571a1.125 1.125 0 010-2.25c.621 0 1.687 1.066 1.687 1.688 0 .621-1.066.562-1.687.562zm11.812 0c-.621 0-1.687.06-1.687-.562 0-.622 1.066-1.688 1.687-1.688a1.125 1.125 0 010 2.25z"
});

function SvgAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAuto;